<template>
    <Button icon="pi pi-sign-in" :type="type" class="p-button-sm bg-blue-700" />
</template>

<script>
import { defineComponent } from "vue";
import Button from "primevue/button";
export default defineComponent({
    components: {
        Button,
    },
    props: {
        type: {
            type: String,
            default: "submit",
        },
    },
});
</script>
